import { Link } from 'react-router-dom';

// US and Philippines flags with partnership text between them
const PartnershipBadge = () => (
  <div className="flex flex-col items-center mb-4">
    {/* Flags and country names - one line */}
    <div className="flex items-center gap-3">
      {/* US Flag - facing right (normal orientation) */}
      <svg className="w-12 h-8 flex-shrink-0" viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="32" fill="#B22234" rx="1"/>
        {/* White stripes */}
        <rect y="4.92" width="48" height="2.46" fill="white"/>
        <rect y="9.85" width="48" height="2.46" fill="white"/>
        <rect y="14.77" width="48" height="2.46" fill="white"/>
        <rect y="19.69" width="48" height="2.46" fill="white"/>
        <rect y="24.62" width="48" height="2.46" fill="white"/>
        <rect y="29.54" width="48" height="2.46" fill="white"/>
        {/* Blue canton */}
        <rect width="19.2" height="17.23" fill="#3C3B6E"/>
        {/* Stars */}
        <circle cx="3.2" cy="2.8" r="0.9" fill="white"/>
        <circle cx="6.4" cy="5.6" r="0.9" fill="white"/>
        <circle cx="3.2" cy="8.4" r="0.9" fill="white"/>
        <circle cx="9.6" cy="2.8" r="0.9" fill="white"/>
        <circle cx="12.8" cy="5.6" r="0.9" fill="white"/>
        <circle cx="9.6" cy="8.4" r="0.9" fill="white"/>
        <circle cx="16" cy="2.8" r="0.9" fill="white"/>
        <circle cx="16" cy="8.4" r="0.9" fill="white"/>
        <circle cx="6.4" cy="11.2" r="0.9" fill="white"/>
        <circle cx="12.8" cy="11.2" r="0.9" fill="white"/>
        <circle cx="3.2" cy="14" r="0.9" fill="white"/>
        <circle cx="9.6" cy="14" r="0.9" fill="white"/>
        <circle cx="16" cy="14" r="0.9" fill="white"/>
      </svg>
      
      {/* Text in the middle */}
      <span className="text-slate-300 text-xs font-medium whitespace-nowrap">
        United States of America – Philippines Partnership
      </span>
      
      {/* Philippines Flag - facing right */}
      <svg className="w-12 h-8 flex-shrink-0" viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="32" fill="#0038A8" rx="1"/>
        <rect y="16" width="48" height="16" fill="#CE1126"/>
        {/* White triangle */}
        <path d="M0 0L24 16L0 32V0Z" fill="white"/>
        {/* Sun */}
        <circle cx="9" cy="16" r="4" fill="#FCD116"/>
        {/* Sun rays */}
        <line x1="9" y1="10" x2="9" y2="6" stroke="#FCD116" strokeWidth="1.2"/>
        <line x1="9" y1="22" x2="9" y2="26" stroke="#FCD116" strokeWidth="1.2"/>
        <line x1="3" y1="16" x2="0" y2="16" stroke="#FCD116" strokeWidth="1.2"/>
        <line x1="15" y1="16" x2="18" y2="16" stroke="#FCD116" strokeWidth="1.2"/>
        <line x1="4.8" y1="11.8" x2="2.4" y2="9.4" stroke="#FCD116" strokeWidth="1.2"/>
        <line x1="13.2" y1="20.2" x2="15.6" y2="22.6" stroke="#FCD116" strokeWidth="1.2"/>
        <line x1="4.8" y1="20.2" x2="2.4" y2="22.6" stroke="#FCD116" strokeWidth="1.2"/>
        <line x1="13.2" y1="11.8" x2="15.6" y2="9.4" stroke="#FCD116" strokeWidth="1.2"/>
        {/* Three stars */}
        <circle cx="3" cy="6" r="1.5" fill="#FCD116"/>
        <circle cx="3" cy="26" r="1.5" fill="#FCD116"/>
        <circle cx="18" cy="16" r="1.5" fill="#FCD116"/>
      </svg>
    </div>
    
    {/* Stacked location and email - centered */}
    <div className="text-center mt-2">
      <p className="text-slate-400 text-sm">Tacloban City, Philippines</p>
      <a
        href="mailto:info@hagen-family-foundation.com"
        className="text-slate-400 hover:text-white transition-colors text-sm"
      >
        info@hagen-family-foundation.com
      </a>
    </div>
  </div>
);

const projectLinks = [
  { name: 'NoMoreScamCalls', url: '#' },
  { name: 'Scaminaters', url: '#' },
];

const legalLinks = [
  { name: 'Privacy', url: '#' },
  { name: 'Terms', url: '#' },
];

const quickLinks = [
  { name: 'Home', path: '/' },
  { name: 'Mission', path: '/mission' },
  { name: 'Initiatives', path: '/initiatives' },
  { name: 'Graduates', path: '/graduates' },
  { name: 'Blog', path: '/blog' },
  { name: 'Contact', path: '/contact' },
];

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-slate-800 text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-blue-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">H</span>
              </div>
              <span className="font-semibold text-lg">
                Hagen-Family-Foundation
              </span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Supporting families and communities with tools that prevent scams and helping young people attain higher education for a brighter future.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    data-testid={`footer-link-${link.name.toLowerCase()}`}
                    className="text-slate-400 hover:text-white text-sm transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Projects */}
          <div>
            <h4 className="font-semibold text-white mb-4">Our Projects</h4>
            <ul className="space-y-2">
              {projectLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.url}
                    data-testid={`footer-project-${link.name.toLowerCase()}`}
                    className="text-slate-400 hover:text-white text-sm transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-6">
              <h4 className="font-semibold text-white mb-3">Legal</h4>
              <ul className="space-y-2">
                {legalLinks.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.url}
                      data-testid={`footer-legal-${link.name.toLowerCase()}`}
                      className="text-slate-400 hover:text-white text-sm transition-colors"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="font-semibold text-white mb-4">Stay Updated</h4>
            <p className="text-slate-400 text-sm mb-4">
              Subscribe for updates on our initiatives and impact.
            </p>
            <form className="space-y-3" onSubmit={(e) => e.preventDefault()}>
              <input
                type="email"
                placeholder="Your email address"
                data-testid="newsletter-email"
                className="w-full bg-slate-700 border border-slate-600 rounded-md px-4 py-2.5 text-white placeholder:text-slate-500 text-sm focus:outline-none focus:border-blue-500 transition-colors"
              />
              <button
                type="submit"
                data-testid="newsletter-submit"
                className="w-full bg-blue-600 hover:bg-blue-700 text-white rounded-md px-4 py-2.5 font-medium text-sm transition-colors"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>
        
        {/* US-Philippines Partnership - Centered */}
        <div className="flex justify-center mt-10">
          <PartnershipBadge />
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-700">
        <div className="container mx-auto px-4 md:px-8 py-5">
          <div className="flex flex-col md:flex-row items-center justify-between gap-3">
            <p className="text-slate-500 text-sm">
              © {new Date().getFullYear()} Hagen-Family-Foundation. All rights reserved.
            </p>
            <p className="text-slate-500 text-sm">
              Pending 501(c)(3) nonprofit status
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
